const selectLogoDestinationUrl = state =>
  state.account?.online_ordering_general_settings?.logo_destination_url;

export default selectLogoDestinationUrl;
